import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";


const Childsafety = () => {
const navigate = useNavigate();
const [sticky, setSticky] = useState("");
const goToAboutSection = (name) => {
    navigate("/#"+name);
  };
  const classes = `main-header ${sticky} mobhide`;
  useEffect(() => {
        // fetchcourses();
        const handleScroll = () => {
         // sticky header
    
         const scrollTop = window.scrollY;
        const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
        setSticky(stickyClass);
        console.log(stickyClass);
       };
    
        window.addEventListener("scroll", handleScroll);
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    
      }, []);
  
  return (
    <div className="main-body">
      {/* Terms & condition */}
    <section>
        <div className="termsconditionsmaindiv">
            <div className="container">
                <p className="about-head termsconditionshead">Child Safety Standards – Mansthal</p>
                <p className="terms-description">
                    Effective Date: 12th August 2025
                </p>
                <p className="terms-description">Mansthal is committed to ensuring a safe and secure environment for all users. We strictly prohibit any form of child sexual abuse and exploitation (CSAE) on our platform.</p>
                <br />

                <p className="termshead">1. Zero Tolerance Policy</p>
                <p className="terms-description">
                  We do not allow: <br />
                  a) Any content involving child sexual abuse or exploitation <br />
                  b) Any inappropriate interaction involving minors<br />
                  c) Sharing, uploading, or distributing harmful or illegal content

                </p>

                <p className="termshead">2. Monitoring & Action</p>
                <p className="terms-description">
                a) We actively monitor content and user activity<br />
                b) Any violation will result in immediate account suspension or removal<br />
                c) We may report illegal activities to law enforcement authorities<br />
                </p>

                <p className="termshead">3. Reporting</p>
                <p className="terms-description">
                Users can report any suspicious or harmful activity directly through the app or by contacting us.
                </p>

                <p className="termshead">4. Contact Us</p>
                <p className="terms-description">
                If you find any content that violates our policies, please contact us immediately: <strong>info@mansthal.com</strong>
                </p>

                
            </div>
        </div>
    </section>
    </div>
  );
};

export default Childsafety;
